export default __webpack_public_path__ + "static/media/larvia-logo-mini-sidebar.55c0cb11.webp";